// NPC "hosts" that frame each Personal-tab section as an in-world "getting to
// know you" conversation. Mirrors the frozen TRAIT_POLES NPC lenses
// (00-FROZEN-CONTRACT §2.1 / §2.3): social_energy+relationship_pace → Mara,
// openness → Sister Lyra, emotional_expression+romance_style → Rooftop Poet,
// stability_vs_adventure → Old Tomas, play_competitiveness → Vex.
//
// `npcId` is intentionally left undefined until the real PROD NPC guids are
// supplied (there is NO NPC roster endpoint — guids live in the PROD DB). While
// undefined, NpcSectionHeader renders name-only from `npcName`; once a guid is
// known it best-effort enriches the bubble via GET /api/npcs/{id}/card.

// Local narrow trait-dimension type — kept dependency-free so W1 does not gate
// on WU-W0. Will unify with memory.ts TraitDimensionKey once WU-W0 lands.
export type TraitDimensionKey =
  | 'social_energy'
  | 'openness'
  | 'emotional_expression'
  | 'stability_vs_adventure'
  | 'play_competitiveness'
  | 'romance_style'
  | 'relationship_pace';

export interface NpcSectionHost {
  sectionKey: 'basics' | 'meet' | 'interests' | 'about';
  title: string;
  npcName: string;
  dimension?: TraitDimensionKey;
  bubble: string;
  npcId?: string;
}

export const NPC_SECTION_HOSTS: NpcSectionHost[] = [
  {
    sectionKey: 'basics',
    title: 'The basics',
    npcName: 'Mara',
    bubble: "Tell me who you are — I'll remember.",
  },
  {
    sectionKey: 'meet',
    title: "Who you'd like to meet",
    npcName: 'Mara',
    dimension: 'relationship_pace',
    bubble: "So — who makes your heart do the thing? No wrong answers.",
  },
  {
    sectionKey: 'interests',
    title: 'Interests',
    npcName: 'Sister Lyra',
    dimension: 'openness',
    bubble: 'What lights you up? Pick a few — curiosity looks good on you.',
  },
  {
    sectionKey: 'about',
    title: 'About you',
    npcName: 'Rooftop Poet',
    dimension: 'emotional_expression',
    bubble: 'A few honest lines. The world remembers the ones who mean it.',
  },
];

/** Resolve a section's host. Every sectionKey is always present. */
export function npcHostFor(sectionKey: NpcSectionHost['sectionKey']): NpcSectionHost {
  return NPC_SECTION_HOSTS.find((h) => h.sectionKey === sectionKey)!;
}
